// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react-hooks/rules-of-hooks */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-param-reassign */
import React, { useState } from "react";
import {
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Popper,
  Paper,
  ClickAwayListener,
  Fade,
  TableSortLabel,
  Button,
  Box,
  Chip,
  Divider,
  IconButton,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import SurroundSoundOutlinedIcon from "@mui/icons-material/SurroundSoundOutlined";
import { format } from "date-fns";
import { useSnackbar } from "notistack";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PauseIcon from "@mui/icons-material/Pause";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import MyLocationOutlinedIcon from "@mui/icons-material/MyLocationOutlined";
import { useNavigate } from "react-router-dom";
import { FilterListOutlined } from "@mui/icons-material";
import { selectPollingInterval } from "../../redux/pollingSlice";
import BackdropSpinner from "../../components/Backdrop/BackdropSpinner";
import PollingInterval from "../../components/PollingInterval/PollingInterval";
import {
  useDeleteInstanceMutation,
  useGetInstanceByIdQuery,
  useGetInstanceQuery,
  useLaunchInstanceMutation,
  usePauseInstanceMutation,
  useExportInstancesMutation,
  useExportReaderInformationMutation,
  useGetRadeaInstanceInformationMutation,
} from "../../redux/api/instanceApi";
import usePagination from "../../hooks/usePagination";
import customTheme from "../../theme/customTheme";
import Styled from "../../theme/CustomMenu/customMenu";
import StyledTable from "../../theme/CustomTable/CustomTable";
import StyledMenu from "../../components/StyledMenu";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import { useAppSelector } from "../../hooks/storeHooks";
import { setTableSeting } from "../../redux/settingSlice";
import { setUserAuth } from "../../redux/userSlice";
import { ApplicationTypes, UserRolesEnum, ExportTypeEnum } from "../../utils/enum/enum";
import {
  useAssignExtensionMutation,
  useGetExtensionImagesQuery,
} from "../../redux/api/extensionApi";
import useDebounce from "../../hooks/useDebounce";
import Search from "../../components/Search";
import InstanceStatusDialogue from "./InstanceStatusDialogue/InstanceStatusDialogue";
import FindDevice from "./FindDevice/FindDevice";
import AddExtension from "./AddExtension/AddExtension";
import Devices from "./Devices/Devices";
import InstanceDetails from "./InstanceDetails";
import {
  calcLicenceExpiration,
  getTimeDifferenceInDays,
  transformServiceLevelToString,
} from "../../utils/functions/functions";
import {
  getSalesContactData,
  getContactData,
  getDeployedApplicationsData
} from "./InstanceFunctions";
import InstanceFilterPanel from "./InstanceFilterPanel";
import { defaultInstanceFilters, InstanceFilters } from "../../utils/types/types";

enum SortingDirectionEnum {
  ASCENDING = "asc",
  DESCENDING = "desc",
}

type SortingDirection = `${SortingDirectionEnum}`;

type HeadCell = {
  id: string;
  label: string;
  isSorting: boolean;
};

const headCells: readonly HeadCell[] = [
  {
    id: "name",
    label: "Instance",
    isSorting: true,
  },
  {
    id: "CustomerName.0",
    label: "Customer Contact",
    isSorting: true,
  },
  {
    id: "Sales Contact",
    label: "Sales Contacts",
    isSorting: true,
  },
  {
    id: "subscription_valid_until",
    label: "Licence Expiration",
    isSorting: true,
  },
  {
    id: "service_level",
    label: "Service Level",
    isSorting: false,
  },
  {
    id: "Version",
    label: "Version",
    isSorting: false,
  },
  {
    id: "Last Process List",
    label: "Last Process List",
    isSorting: false,
  },
  {
    id: "Status",
    label: "Status",
    isSorting: false,
  },
];

const intervalOptions = [
  { label: "Off", value: 0 },
  { label: "1s", value: 1000 },
  { label: "2s", value: 2000 },
  { label: "3s", value: 3000 },
  { label: "5s", value: 5000 },
  { label: "10s", value: 10000 },
  { label: "1m", value: 60000 },
];

export default function InstanceManagement() {
  const { user } = useAppSelector(setUserAuth);
  //for pagination
  const {
    rowsPerPage,
    page,
    setPage,
    handleChangeRowsPerPage,
    handleChangePage,
  } = usePagination();
  //for devices
  const [showDevices, setShowDevices] = useState(false);
  //for instance dialog
  const [showInstance, setShowInstance] = useState(false);
  //for extensions
  const [assignExtension] = useAssignExtensionMutation();
  const { data: extensionData } = useGetExtensionImagesQuery();
  // Filter objects with names "radeaio-core-backend" and "radeaio-core-ui to later extract tags at index 0"

  const backendTags = extensionData?.results?.find(
    (obj) => obj?.name === ApplicationTypes.BACKEND
  )?.tags;

  const backendLatestTag = backendTags
    ? backendTags[0]?.name === "latest"
      ? backendTags[1]?.id
      : backendTags[0]?.id
    : "";

  const frontendLatestTag = extensionData?.results?.filter(
    (obj) => obj?.name === ApplicationTypes.FRONTEND
  )?.[0]?.tags[0]?.id;

  //for extension end
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [showFindDevice, setShowFindDevice] = useState(false);
  const [showInstanceStatusDialog, setShowInstanceStatusDialog] =
    useState(false);
  const { value } = useAppSelector(selectPollingInterval);
  const [name, setName] = React.useState("");
  const debounceValue = useDebounce(name, 700);
  const { enqueueSnackbar } = useSnackbar();
  const { dense } = useAppSelector(setTableSeting);
  const [instanceFilters, setInstanceFilters] = useState<InstanceFilters>(defaultInstanceFilters);
  const [version, setVersion] = React.useState<string>("");
  const debouncedVersion = useDebounce(version, 700);
  const { serviceLevel } = instanceFilters;
  const { data: Instance } = useGetInstanceQuery(
    { debounceValue, page, rowsPerPage, version: debouncedVersion, serviceLevel },
    {
      pollingInterval: value,
    }
  );
  const [isFilterOpen, setIsFilterOpen] = React.useState<boolean>(false);

  const [launchInstance, { isLoading }] = useLaunchInstanceMutation();
  const [handleDelete] = useDeleteInstanceMutation();
  const [handlePause] = usePauseInstanceMutation();
  const [exportInstances, { isLoading: isExportingInstances }] = useExportInstancesMutation();
  const [exportReaderInformation, { isLoading: isExportingReaderInformation }] = useExportReaderInformationMutation();
  const [getInstanceInformation, { isLoading: isLoadingInstanceInformation }] = useGetRadeaInstanceInformationMutation();
  const [order, setOrder] = useState<SortingDirection>(
    SortingDirectionEnum.DESCENDING
  );
  const [orderBy, setOrderBy] = useState("name");

  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [confirmationPauseDialog, setConfirmationPauseDialog] = useState(false);
  const [rowId, setRowId] = useState<number | undefined>(undefined);
  const [editId, setEditId] = useState<number | undefined>(undefined);
  const rowIdString = rowId ? rowId.toString() : "";
  const editIdString = editId ? editId.toString() : "";
  const [editCreatorUsername, setEditCreatorUsername] = useState("");

  const { data: singleInstance } = useGetInstanceByIdQuery(rowIdString, {
    refetchOnMountOrArgChange: true,
  });

  //collect non applications extension and integrations

  const integrationsData =
    singleInstance?.assigned_instance_tags?.extensions?.integrations;
  const verticalData =
    singleInstance?.assigned_instance_tags?.extensions?.verticals;

  const assignedIntegrationTags = Object?.values(integrationsData || {})?.map(
    (item) => item?.tag_id
  );
  const assignedVerticalTags = Object?.values(verticalData || {})?.map(
    (item) => item?.tag_id
  );

  //assigned tags for applications. Below if a value is selected then it will be used else the latest tag will be used

  const allApplications = singleInstance?.assigned_instance_tags?.applications;

  const assignedFrontendApplicationTag = allApplications?.[
    ApplicationTypes.FRONTEND
  ]?.tag_id
    ? allApplications?.[ApplicationTypes.FRONTEND]?.tag_id
    : frontendLatestTag;

  const assignedBackendApplicationTag = allApplications?.[
    ApplicationTypes.BACKEND
  ]?.tag_id
    ? allApplications?.[ApplicationTypes.BACKEND]?.tag_id
    : backendLatestTag;

  const [open, setOpen] = React.useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [anchorEl, setAnchorEl] = React.useState<null | any>(null);

  const handleFindDialog = () => {
    setShowFindDevice(false);
  };

  const handleCopyUrl = () => {
    Instance?.results?.forEach(({ id, frontend_url: url }) => {
      if (id === rowId) {
        navigator.clipboard.writeText(url);
      }
    });
    setOpen(false);
    setRowId(undefined);
  };

  function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    const aValue = a[orderBy];
    const bValue = b[orderBy];

    // Check if values are strings before using localeCompare
    if (typeof aValue === "string" && typeof bValue === "string") {
      return bValue.localeCompare(aValue);
    }

    // Fallback to regular comparison if values are not strings
    if (bValue < aValue) {
      return -1;
    }
    if (bValue > aValue) {
      return 1;
    }
    return 0;
  }

  function getComparator(order: SortingDirection, orderBy: string) {
    return order === SortingDirectionEnum.ASCENDING
      ? (a: Record<string, unknown>, b: Record<string, unknown>) =>
        descendingComparator(a, b, orderBy)
      : (a: Record<string, unknown>, b: Record<string, unknown>) =>
        -descendingComparator(a, b, orderBy);
  }

  const handleDeleteDialog = () => {
    setConfirmationDialog(false);
  };
  const handlePauseDialog = () => {
    setConfirmationPauseDialog(false);
  };
  const handleInstanceStatusDialog = () => {
    setShowInstanceStatusDialog(false);
    setEditId(undefined);
    setEditCreatorUsername("");
    setRowId(undefined);
    setOpen(false);
  };

  //for extensions
  const handleCloseDialog = () => {
    setEditId(undefined);
    setEditCreatorUsername("");
    setRowId(undefined);
    setShowDialog(false);
    setOpen(false);
  };

  // for instance details
  const handleInstanceDetailsDialog = () => {
    setShowInstance(false);
  };

  const handleDeleteInstance = (rowId: string) => {
    handleDelete(rowId)
      .unwrap()
      .then((payload) => {
        if (payload) {
          enqueueSnackbar("Instance Deleted", {
            variant: "success",
            autoHideDuration: 2000,
          });
        }
      })
      .catch((error) => {
        if (error) {
          enqueueSnackbar(`Failed to delete, ${error?.data?.detail}`, {
            variant: "error",
            autoHideDuration: 5000,
          });
        }
      });
    setConfirmationDialog(false);
    setRowId(undefined);
  };

  const handlePauseInstance = (rowId: string) => {
    handlePause(rowId)
      .unwrap()
      .then((payload) => {
        if (payload) {
          enqueueSnackbar("Instance Paused", {
            variant: "success",
            autoHideDuration: 2000,
          });
        }
      })
      .catch((error) => {
        if (error) {
          enqueueSnackbar(
            `Failed to paused, try again, ${error?.data?.detail}`,
            {
              variant: "error",
              autoHideDuration: 5000,
            }
          );
        }
      });
    setOpen(false);
    setRowId(undefined);
  };

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: string
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      handleRequestSort(event, property);
    };

  const handleClose = () => {
    setOpen(false);
    setRowId(undefined);
  };

  //get instance status for launch code when instance is paused

  const getPausedStatus = () => {
    if (singleInstance?.is_launched && singleInstance?.status === "paused") {
      return true;
    }
    return false;
  };

  const handleLaunchInstance = () => {
    if (getPausedStatus()) {
      launchInstance(rowIdString)
        .unwrap()
        .then((payload) => {
          if (payload) {
            enqueueSnackbar("Instance Initiated", {
              variant: "success",
              autoHideDuration: 2000,
            });
          }
        })
        .catch((error) => {
          if (error) {
            enqueueSnackbar(
              `Instance Failed to initiate, ${error?.data?.detail}`,
              {
                variant: "error",
                autoHideDuration: 2000,
              }
            );
          }
        });
    } else {
      const allTags = [
        assignedFrontendApplicationTag,
        assignedBackendApplicationTag,
        ...assignedIntegrationTags,
        ...assignedVerticalTags,
      ];
      const dataToSubmit = { tag_ids: allTags };
      assignExtension({ dataToSubmit, id: rowIdString })
        .unwrap()
        .then(() => {
          enqueueSnackbar("Extensions assigned to the instance.", {
            variant: "success",
            autoHideDuration: 2000,
          });
          launchInstance(rowIdString)
            .unwrap()
            .then((payload) => {
              if (payload) {
                enqueueSnackbar("Instance Initiated", {
                  variant: "success",
                  autoHideDuration: 2000,
                });
              }
            })
            .catch((error) => {
              if (error) {
                enqueueSnackbar(
                  `Instance Failed to initiate, ${error?.data?.detail}`,
                  {
                    variant: "error",
                    autoHideDuration: 2000,
                  }
                );
              }
            });
        })
        .catch((error) => {
          enqueueSnackbar(`Failed to add extensions, ${error?.data?.detail}`, {
            variant: "error",
            autoHideDuration: 2000,
          });
        });
    }
    setOpen(false);
    setRowId(undefined);
  };

  const fetchInstanceInformation = () => {
    getInstanceInformation(rowIdString)
      .unwrap()
      .then(() => {
        enqueueSnackbar("Instance information fetched", {
          variant: "success",
          autoHideDuration: 2000,
        })
      })
      .catch((error) => {
        if (error) {
          enqueueSnackbar("Failed to fetch instance information", {
            variant: "error",
            autoHideDuration: 5000,
          });
        }
      });
  }

  const handleContextMenu = (e: React.MouseEvent, rowId: number, creatorUsername: string) => {
    e.preventDefault();
    e.stopPropagation();
    const { clientX, clientY } = e;
    setOpen(true);
    setRowId(rowId);
    setEditId(rowId);
    setEditCreatorUsername(creatorUsername);

    const virtualElement = {
      getBoundingClientRect: () => ({
        width: 0,
        height: 0,
        top: clientY,
        right: clientX,
        bottom: clientY,
        left: clientX,
      }),
    };
    setAnchorEl(virtualElement);
  };
  const id = open ? "instance-managment-menu" : undefined;

  // check if user can change the instance
  function checkCreatorPerm(creatorUsername: string) {
    if (user?.roles.includes(UserRolesEnum.ADMINISTRATOR)) {
      return true;
    }
    if (user?.roles.includes(UserRolesEnum.OPERATOR) && user?.username === creatorUsername) {
      return true;
    }
    return false;
  }

  // get background color of table row
  function getTableRowColor(
    selectedRowId: number | undefined
  ) {
    const highlightColor = customTheme.palette.secondary.main;
    const defaultColor = customTheme.palette.secondary.light;
    if (selectedRowId) {
      return selectedRowId === rowId ? highlightColor : defaultColor;
    }
    return defaultColor;
  }

  function getStatusColors(status: string) {
    if (status === "running") {
      return "success";
    }
    if (status === "not initialized") {
      return "warning";
    }
    if (status === "deleting") {
      return "error";
    }
    return "info";
  }

  function canInstanceBeLaunched(): boolean {
    const { is_launched: isLaunched = false, status = "invalid" } = singleInstance || {};

    if ([
      "not initialized",
      "initializing failed",
      "paused"
    ].includes(status)) {
      return true;
    }

    // this should be covered by the above but just in case...
    if (!isLaunched) {
      return true;
    }

    return false;
  }

  function canInstanceBePaused(): boolean {
    const { is_launched: isLaunched = false, status = "invalid" } = singleInstance || {};

    if (isLaunched && [
      "running",
      "not running",
      "deleting failed",
      "pausing failed",
      "updated",
      "updating failed",
    ].includes(status)) {
      return true;
    }

    return false;
  }
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
    setPage(1);
  };

  const handleDevices = () => {
    setEditId(undefined);
    setRowId(undefined);
    setShowDevices(false);
    setOpen(false);
  };

  // Export menu
  const [anchorElExportMenu, setAnchorElExportMenu] = React.useState<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    null | any
  >(null);
  const openExportMenu = Boolean(anchorElExportMenu);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElExportMenu(event.currentTarget);
  };
  const handleCloseExportMenu = () => {
    setAnchorElExportMenu(null);
  };

  const handleExportInstances = (exportType: ExportTypeEnum) => {
    exportInstances({exportType})
      .unwrap()
      .then(() => {
        enqueueSnackbar("Instances exported", {
          variant: "success",
          autoHideDuration: 2000,
        })
      })
      .catch((error) => {
      if (error) {
        enqueueSnackbar("Failed to export instances", {
          variant: "error",
          autoHideDuration: 5000,
        });
      }
    });
  };

  const handleExportReaderInformation = (exportType: ExportTypeEnum) => {
    exportReaderInformation({exportType})
    .unwrap()
      .then(() => {
        enqueueSnackbar("Reader information exported", {
          variant: "success",
          autoHideDuration: 2000,
        })
      })
      .catch((error) => {
      if (error) {
        enqueueSnackbar("Failed to export reader information", {
          variant: "error",
          autoHideDuration: 5000,
        });
      }
    });
  };

  const handleInstanceFilters = (newFilters: InstanceFilters) => {
    setInstanceFilters(newFilters);
    const { version: newVersion } = newFilters;
    setVersion(newVersion);
  }
  
  const timeNow = Date.now()

  return (
    <Box sx={{ width: "100%" }}>
      <InstanceFilterPanel
        open={isFilterOpen}
        handleClose={() => setIsFilterOpen(false)}
        filters={instanceFilters}
        setFilters={handleInstanceFilters}
      />
      {isLoading && <BackdropSpinner open={isLoading} />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Search name={name} handleSearch={handleSearch} />
          <Button
            variant="contained"
            onClick={() => {
              navigate("/add-edit-instance", {
                state: { isInitialized: false, id: "" },
              });
              setEditId(undefined);
              setEditCreatorUsername("");
            }}
            sx={{ ml: "2rem" }}
          >
            <AddCircleIcon sx={{ marginRight: "0.5rem" }} /> Create Instance
          </Button>
          <Button
            variant="contained"
            onClick={(event) => handleClick(event)}
            sx={{ ml: "1rem" }}
          >
            Export
          </Button>
          <StyledMenu
            anchorEl={anchorElExportMenu}
            id="action-menu-button"
            open={openExportMenu}
            onClose={handleCloseExportMenu}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick={(event: { stopPropagation: any; }) => {
              // eslint-disable-next-line no-unused-expressions
              event.stopPropagation;
              // eslint-disable-next-line no-unused-expressions
              handleCloseExportMenu;
            }}
          >
            <MenuItem
              onClick={() => handleExportInstances(ExportTypeEnum.CSV)}
              disabled={ isExportingInstances }
            >
                {isExportingInstances ? "Exporting..." : "Export instance data as CSV"}
            </MenuItem>
            <MenuItem
              onClick={() => handleExportInstances(ExportTypeEnum.XLSX)}
              disabled={ isExportingInstances }
            >
                {isExportingInstances ? " " : "Export instance data as XLSX"}
            </MenuItem>
            <Divider orientation="horizontal" flexItem/>
            <MenuItem
              onClick={() => handleExportReaderInformation(ExportTypeEnum.CSV)}
              disabled={ isExportingReaderInformation }
            >
                {isExportingReaderInformation ? "Exporting..." : "Export reader information as CSV"}
            </MenuItem>
            <MenuItem
              onClick={() => handleExportReaderInformation(ExportTypeEnum.XLSX)}
              disabled={ isExportingReaderInformation }
            >
                {isExportingReaderInformation ? " " : "Export reader information as XLSX"}
            </MenuItem>
          </StyledMenu>
          <IconButton
            onClick={() => setIsFilterOpen(true)}
          >
            <FilterListOutlined />
          </IconButton>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="text"
            onClick={() => {
              setShowFindDevice(true);
            }}
            sx={{ mr: "1rem" }}
          >
            <MyLocationOutlinedIcon sx={{ marginRight: "0.5rem" }} /> Find
            Device
          </Button>
          <Box sx={{ display: "flex", justifyContent: "flex-end", ml: "10px" }}>
            <PollingInterval options={intervalOptions} />
          </Box>
        </Box>
      </Box>
      <StyledTable>
        <TableContainer>
          <Table
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            sx={dense ? { marginTop: "1rem" } : null}
            style={{ tableLayout: "fixed" }}
          >
            <TableHead>
              <TableRow>
                {headCells.map((item) => (
                  <TableCell key={item.id}>
                    {item.isSorting ? (
                      <TableSortLabel
                        active={orderBy === `${item.id}`}
                        direction={orderBy === `${item.id}` ? order : "asc"}
                        onClick={createSortHandler(item.id)}
                      >
                        {item.label}
                      </TableSortLabel>
                    ) : (
                      item.label
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Instance?.results &&
                Instance?.results
                  ?.slice(rowsPerPage * 0, rowsPerPage * (page + 1))
                  ?.sort(getComparator(order, orderBy))
                  .map(({
                    id,
                    creator,
                    name,
                    parameters,
                    subscription_metadata: metadata,
                    subscription_valid_until: validUntil,
                    service_level: serviceLevel,
                    deployed_instance_tags: deployedTags,
                    last_received_list: lastList,
                    status,
                  }) => (
                    <TableRow
                      key={id}
                      onContextMenu={(event) =>
                        handleContextMenu(event, id, creator)
                      }
                      style={{
                        backgroundColor: getTableRowColor(id),
                      }}
                      sx={{
                        padding: "10px",
                        "& td": {
                          wordBreak: "break-word",
                        },
                      }}
                    >
                      <TableCell>{name}</TableCell>
                      <TableCell>
                        {parameters
                          ? getContactData(parameters)
                          : "Not Set"}
                      </TableCell>
                      <TableCell>
                        {metadata
                          ? getSalesContactData(metadata)
                          : "Not Set"}
                      </TableCell>
                      <TableCell
                        sx={{
                          color:
                            calcLicenceExpiration(
                              validUntil
                            ) ||
                              calcLicenceExpiration(
                                validUntil
                              ) === 0
                              ? customTheme.palette.error.main
                              : "inherit",
                        }}
                      >
                        {validUntil
                          ? format(
                            new Date(validUntil),
                            "dd MMMM yyyy HH:mm"
                          )
                          : "Not Set"}
                      </TableCell>
                      <TableCell>
                        {transformServiceLevelToString(serviceLevel)}
                      </TableCell>
                      <TableCell>
                        {deployedTags
                          ? getDeployedApplicationsData(deployedTags)
                          : "Not Set"}
                      </TableCell>
                      <TableCell>
                        {
                          lastList !== null
                          ? getTimeDifferenceInDays(Date.parse(lastList), timeNow)
                          : ""
                        }
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={status}
                          color={getStatusColors(status)}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
      </StyledTable>
      <TablePagination
        rowsPerPageOptions={[20, 25, 50, 100]}
        component="div"
        count={Instance?.count || 0}
        rowsPerPage={rowsPerPage}
        page={page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {anchorEl && (
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          transition
          placement="bottom-start"
          sx={{ padding: "10px 0px 8px 5px" }}
        >
          {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={handleClose}>
              <Fade {...TransitionProps}>
                <Paper>
                  <Styled>
                    <MenuItem onClick={() => setShowInstance(true)}>
                      <SurroundSoundOutlinedIcon />
                      Instance Details
                    </MenuItem>
                    <MenuItem
                      disabled={!checkCreatorPerm(editCreatorUsername) || !canInstanceBeLaunched()}
                      onClick={() => handleLaunchInstance()}
                    >
                      <RocketLaunchIcon />
                      Launch
                    </MenuItem>
                    <MenuItem
                      disabled={!checkCreatorPerm(editCreatorUsername) || !canInstanceBePaused()}
                      onClick={() => setConfirmationPauseDialog(true)}
                    >
                      <PauseIcon />
                      Pause
                    </MenuItem>
                    <MenuItem
                      disabled={!checkCreatorPerm(editCreatorUsername)}
                      onClick={() =>
                        navigate("/add-edit-instance", {
                          state: {
                            isInitialized: singleInstance?.is_launched,
                            id: editId,
                          },
                        })
                      }
                    >
                      <EditIcon />
                      Edit
                    </MenuItem>
                    <MenuItem
                      disabled={!checkCreatorPerm(editCreatorUsername) || singleInstance?.status === "deleting"}
                      onClick={() => setConfirmationDialog(true)}
                    >
                      <DeleteIcon />
                      Delete
                    </MenuItem>
                    <MenuItem onClick={() => handleCopyUrl()}>
                      <ContentCopyIcon />
                      Copy Url
                    </MenuItem>
                    <MenuItem onClick={() => setShowDialog(true)}>
                      <ExtensionOutlinedIcon />
                      Versions and Extensions
                    </MenuItem>
                    <MenuItem onClick={() => setShowInstanceStatusDialog(true)}>
                      <AnalyticsIcon />
                      Show instance status
                    </MenuItem>
                    <MenuItem onClick={() => setShowDevices(true)}>
                      <SurroundSoundOutlinedIcon />
                      Check devices
                    </MenuItem>
                    <MenuItem
                      onClick={() => fetchInstanceInformation()}
                      disabled={ isLoadingInstanceInformation }
                    >
                      <ContentCopyIcon />
                      {isLoadingInstanceInformation ? "Fetching..." : "Fetch Instance Information"}
                    </MenuItem>
                  </Styled>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      )}
      {confirmationDialog && rowId && (
        <ConfirmationDialog
          isOpen={confirmationDialog}
          onClose={handleDeleteDialog}
          onConfirm={() => handleDeleteInstance(rowIdString)}
          title="Delete Instance"
          confirmText="Confirm"
          isWarning
        >
          Are you sure you want to delete instance, It will delete all customer
          data ?
        </ConfirmationDialog>
      )}
      {confirmationPauseDialog && rowId && (
        <ConfirmationDialog
        isOpen={confirmationPauseDialog}
        onClose={handlePauseDialog}
        onConfirm={() => handlePauseInstance(rowIdString)}
        title="Pause Instance"
        confirmText="Confirm"
        isWarning
      >
        Are you sure you want to pause instance?
      </ConfirmationDialog>
      )}
      {showInstanceStatusDialog && (
        <InstanceStatusDialogue
          handleCloseDialog={handleInstanceStatusDialog}
          id={editIdString}
          isOpen={showInstanceStatusDialog}
        />
      )}
      {showFindDevice && (
        <FindDevice
          isOpen={showFindDevice}
          handleCloseDialog={handleFindDialog}
        />
      )}
      {showDialog && (
        <AddExtension
          isOpen={showDialog}
          handleCloseDialog={handleCloseDialog}
          id={editIdString}
        />
      )}
      {showDevices && (
        <Devices
          handleCloseDialog={handleDevices}
          id={editIdString}
          isOpen={showDevices}
        />
      )}
      {showInstance && (
        <InstanceDetails
          instanceId={editIdString}
          handleClose={handleInstanceDetailsDialog}
          isOpen={showInstance}
        />
      )}
    </Box>
  );
}
